import { ISearchQuery } from '../../types/Interviews/jobRoles.types';
import { IInvitePayload } from '../../types/Interviews/interviews.types';
import { HTTP_METHODS } from '../../constants/HttpConstants';
import { sendRequestToServerWithCredentials } from '../../utils/request';

export const getAllCandidatesApi = (params: ISearchQuery) =>
  sendRequestToServerWithCredentials({
    method: HTTP_METHODS.GET,
    url: '/search/interview/',
    params: params,
    paramsSerializer: (queryParams) => {
      return Object.entries(queryParams)
        .map((queryParam) => {
          const [paramKey, paramValue] = queryParam;
          if (
            (!paramValue && paramValue !== 0) ||
            (typeof paramValue === 'object' && !paramValue.length)
          )
            return null;
          else if (typeof paramValue === 'object' && paramValue.length) {
            return paramValue
              .map((value: any) => [paramKey, value].join('='))
              .join('&');
          }
          return queryParam.join('=');
        })
        .filter((data) => data)
        .join('&');
    },
  });

export const resendInviteApi = (roleSlug: string, payload: IInvitePayload) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `/roles/${roleSlug}/resend_email/`,
    data: payload,
  });
};

export const cancelInviteApi = (roleSlug: string, payload: IInvitePayload) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `/roles/${roleSlug}/cancel_interview/`,
    data: payload,
  });
};
